// This file sets up the main page routes for the KiranaOS frontend.
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import CustomerMenuPage from "./pages/CustomerMenuPage";
import StoreOwnerDashboard from "./pages/StoreOwnerDashboard";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import SuperAdminPage from "./pages/SuperAdminPage";
import OnboardingPage from "./pages/OnboardingPage";
import DemoDashboardPage from "./pages/DemoDashboardPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/store/:storeId" element={<CustomerMenuPage />} />
        <Route path="/dashboard" element={<StoreOwnerDashboard />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/superadmin" element={<SuperAdminPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/demo-dashboard" element={<DemoDashboardPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
